import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    // i18n: keep English as the default and active language (same behavior)
    this.translate.setDefaultLang('en');
    this.translate.use('en');

    // Theme: apply the default theme on load (same behavior)
    this.themeService.setTheme('default');
  }

  applyTheme($event: Event): void {
    const target = $event?.target as HTMLInputElement | null;
    const value = target?.value;
    if (value) {
      this.themeService.setTheme(value);
    }
  }
}
